// @ts-nocheck
import React from 'react';
import RequestsMadeByMeList from '../RequestsMadeByMeList';
import TableViewSwitcher from '../TableViewSwitcher';
import RequestsMadeByMeGroupedList from '../RequestsMadeByMeGroupedList';
import RequestsList from './RequestsList';
import RequestsGroupedList from './RequestsGroupedList';
import { isPowerUser } from '../../../auth/authUtils';
import { useTranslation } from 'react-i18next';

export interface RequestsTableForUserTypeAndDisplayModeProps {
  assignedToMe?: boolean;
  title?: string;
  reload?: unknown;
  itemsChecked: unknown[];
  setItemsChecked?: (checked: unknown[]) => void;
  requestsGrouped: boolean;
  setRequestsGrouped: (grouped: boolean) => void;
  currentUser: Record<string, unknown>;
  setBulkActionsSlideoutOpen: (open: boolean) => void;
  setCompleteRequestSlideoutOpen: (open: boolean) => void;
  setBreadcrumb?: (breadcrumb: unknown) => void;
  scope?: Record<string, unknown>;
  settingsKey?: string;
  handleDownloadKeys: (request: unknown) => void;
  handleUploadKeys: (request: unknown) => void;
  handleBulkStatusChange: (request: unknown) => void;
  handleBulkReassign: (request: unknown) => void;
  handleBulkSteamRequest: (request: unknown) => void;
  handleReturnKeys: (request: unknown) => void;
  isProcessing: boolean;
}

function RequestsTableForUserTypeAndDisplayMode({
  assignedToMe,
  title,
  reload,
  itemsChecked,
  setItemsChecked,
  requestsGrouped,
  setRequestsGrouped,
  currentUser,
  setBulkActionsSlideoutOpen,
  setCompleteRequestSlideoutOpen,
  setBreadcrumb,
  scope,
  settingsKey,
  handleDownloadKeys,
  handleUploadKeys,
  handleBulkStatusChange,
  handleBulkReassign,
  handleBulkSteamRequest,
  handleReturnKeys,
  isProcessing,
}: RequestsTableForUserTypeAndDisplayModeProps) {
  const { t } = useTranslation();
  // Are we a power user?
  if (isPowerUser(currentUser)) {
    // Yes, so show the requests grouped by request group
    if (requestsGrouped) {
      return (
        <RequestsGroupedList
          assignedToMe={assignedToMe}
          title={title}
          reload={reload}
          itemsChecked={itemsChecked}
          setItemsChecked={setItemsChecked}
          handleBulkActions={
            isPowerUser(currentUser) && setBulkActionsSlideoutOpen
          }
          bulkActionTitle={
            itemsChecked.length === 0
              ? t('Bulk actions - first tick some requests')
              : t('Bulk actions')
          }
          tableViewSwitcher={
            <TableViewSwitcher
              requestsGrouped={requestsGrouped}
              setRequestsGrouped={setRequestsGrouped}
              setItemsChecked={setItemsChecked}
            />
          }
          setCompleteRequestSlideoutOpen={setCompleteRequestSlideoutOpen}
          setBreadcrumb={setBreadcrumb}
          scope={scope}
          settingsKey={settingsKey}
        />
      );
    }

    // No, so show the requests in a list
    return (
      <RequestsList
        assignedToMe={assignedToMe}
        title={title}
        reload={reload}
        handleDownloadKeys={handleDownloadKeys}
        handleUploadKeys={handleUploadKeys}
        handleBulkStatusChange={handleBulkStatusChange}
        handleBulkReassign={handleBulkReassign}
        handleBulkSteamRequest={handleBulkSteamRequest}
        handleReturnKeys={handleReturnKeys}
        itemsChecked={itemsChecked}
        setItemsChecked={setItemsChecked}
        isProcessing={isProcessing}
        handleBulkActions={
          isPowerUser(currentUser) && setBulkActionsSlideoutOpen
        }
        bulkActionTitle={
          itemsChecked.length === 0
            ? t('Bulk actions - first tick some requests')
            : t('Bulk actions')
        }
        tableViewSwitcher={
          <TableViewSwitcher
            requestsGrouped={requestsGrouped}
            setRequestsGrouped={setRequestsGrouped}
            setItemsChecked={setItemsChecked}
          />
        }
        setCompleteRequestSlideoutOpen={setCompleteRequestSlideoutOpen}
        setBreadcrumb={setBreadcrumb}
        scope={scope}
        settingsKey={settingsKey}
      />
    );
  }

  // No not a power user, so show the "made by me" requests grouped by request group
  if (requestsGrouped) {
    return (
      <RequestsMadeByMeGroupedList
        reload={reload}
        setCompleteRequestSlideoutOpen={setCompleteRequestSlideoutOpen}
        settingsKey={settingsKey}
        allRequests={true}
        tableViewSwitcher={
          <TableViewSwitcher
            requestsGrouped={requestsGrouped}
            setRequestsGrouped={setRequestsGrouped}
            setItemsChecked={setItemsChecked}
          />
        }
      />
    );
  }

  // No, so show the "made by me" requests in a list
  return (
    <RequestsMadeByMeList
      reload={reload}
      handleDownloadKeys={handleDownloadKeys}
      isProcessing={isProcessing}
      setCompleteRequestSlideoutOpen={setCompleteRequestSlideoutOpen}
      settingsKey={settingsKey}
      allRequests={true}
      tableViewSwitcher={
        <TableViewSwitcher
          requestsGrouped={requestsGrouped}
          setRequestsGrouped={setRequestsGrouped}
          setItemsChecked={setItemsChecked}
        />
      }
    />
  );
}

export default RequestsTableForUserTypeAndDisplayMode;
